// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ripples only — soft edge fade, no hard rectangular frame */
.hero_section_main .banner_img {
  position: relative;
  overflow: visible;
}

.hero_section_main .banner_img .hero-ripple-canvas-wrap {
  position: absolute;
  left: 50%;
  bottom: -140px;
  transform: translateX(-50%);
  width: min(160%, 1200px);
  max-width: min(96vw, 1200px);
  pointer-events: none;
  z-index: 0;
  opacity: 0.18;
  /* feather left/right — no sharp canvas “box” */
  mask-image: linear-gradient(90deg,
      transparent 0%,
      rgba(0, 0, 0, 0.45) 6%,
      #000 14%,
      #000 86%,
      rgba(0, 0, 0, 0.45) 94%,
      transparent 100%);
  -webkit-mask-image: linear-gradient(90deg,
      transparent 0%,
      rgba(0, 0, 0, 0.45) 6%,
      #000 14%,
      #000 86%,
      rgba(0, 0, 0, 0.45) 94%,
      transparent 100%);
}

.hero_section_main .banner_img .banner_img_main {
  position: relative;
  z-index: 1;
}

.hero_section_main .banner_img .hero-ripple-canvas {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 1000 / 380;
  vertical-align: top;
}

@media screen and (max-width: 767.98px) {
  .hero_section_main .banner_img .hero-ripple-canvas-wrap {
    width: min(180%, 100vw);
    max-width: none;
    bottom: -4%;
    opacity: 0.2;
  }

  .hero_section_main .banner_img {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/LandingPage/HeroRippleCanvas.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,+CAA+C;EAC/C;;;;;;uBAMqB;EACrB;;;;;;uBAMqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Ripples only — soft edge fade, no hard rectangular frame */\n.hero_section_main .banner_img {\n  position: relative;\n  overflow: visible;\n}\n\n.hero_section_main .banner_img .hero-ripple-canvas-wrap {\n  position: absolute;\n  left: 50%;\n  bottom: -140px;\n  transform: translateX(-50%);\n  width: min(160%, 1200px);\n  max-width: min(96vw, 1200px);\n  pointer-events: none;\n  z-index: 0;\n  opacity: 0.18;\n  /* feather left/right — no sharp canvas “box” */\n  mask-image: linear-gradient(90deg,\n      transparent 0%,\n      rgba(0, 0, 0, 0.45) 6%,\n      #000 14%,\n      #000 86%,\n      rgba(0, 0, 0, 0.45) 94%,\n      transparent 100%);\n  -webkit-mask-image: linear-gradient(90deg,\n      transparent 0%,\n      rgba(0, 0, 0, 0.45) 6%,\n      #000 14%,\n      #000 86%,\n      rgba(0, 0, 0, 0.45) 94%,\n      transparent 100%);\n}\n\n.hero_section_main .banner_img .banner_img_main {\n  position: relative;\n  z-index: 1;\n}\n\n.hero_section_main .banner_img .hero-ripple-canvas {\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 1000 / 380;\n  vertical-align: top;\n}\n\n@media screen and (max-width: 767.98px) {\n  .hero_section_main .banner_img .hero-ripple-canvas-wrap {\n    width: min(180%, 100vw);\n    max-width: none;\n    bottom: -4%;\n    opacity: 0.2;\n  }\n\n  .hero_section_main .banner_img {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
